module.exports = __webpack_public_path__ + "img/service-part11-1.a8e6620d.png";